"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getBlockElementAtNode_1 = require("./getBlockElementAtNode");
/**
 * Get the first/last BlockElement of under the root node.
 * If no suitable BlockElement found, returns null
 * @param rootNode The root node to get BlockElement from
 * @param isFirst True to get first BlockElement, false to get last BlockElement
 */
function getFirstLastBlockElement(rootNode, isFirst) {
    var node = rootNode;
    do {
        node = node && (isFirst ? node.firstChild : node.lastChild);
    } while (node && node.firstChild);
    return (node && (0, getBlockElementAtNode_1.default)(rootNode, node)) || null;
}
exports.default = getFirstLastBlockElement;
//# sourceMappingURL=getFirstLastBlockElement.js.map